export default __webpack_public_path__ + "static/media/new-bg.f9c1ade8.png";